export enum MailCreationType {
  System = 1,
  User = 2,
}
